import React from 'react';

export const Loading = ({nombre}) => {
    return (
            <>
                    <div className= {` absolute `}>
                        <div className="flex mt-[20%] ml-[90%] z-50 loading">{nombre ||'Generando QR...'}
                            <div className="spinner-sec spin-sec-one"></div>
                            <div className="spinner-sec spin-sec-two"></div>
                            <div className="spinner-sec spin-sec-three"></div>
                        </div>
                    </div>
            </>

        )
} 
